<template>
  <div class="w-100 row mb-5 mt-4">
        <div class="row p-list-salon-owner-upload-file-main">
              <h3 class="p-list-salon-owner-upload-title justify-content-center w-100 d-flex mb-3">{{text}}</h3>

              <div class="w-100 row">
                  <div class="d-flex justify-content-center  p-list-salon-owner-uload-file-data position-relative">
                    <img :src="previewImage" v-if=" previewImage != '' " class="p-list-salon-owner-pic-upload" alt="">
                  </div>
                  <div class="d-flex p-list-salon-owner-upload-delete justify-content-end w-100 mt-2 mb-2">
                    <button @click="removePic" type="button" class="btn btn-primary btn-red remove-radius col-lg-4">حذف</button>
                  </div>
              </div>

              <div class="p-list-representation-select-modal-main row justify-content-center">
                    <div class="input-group ltr ">
                        <div class="input-group-prepend">
                          <span id="inputGroupFileAddon01" class="input-group-text">انتخاب فایل</span>
                        </div>
                        <div class="custom-file">
                          <input @change="uploadImage" type="file" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" class="custom-file-input">
                          <label for="inputGroupFile01" class="custom-file-label">
                          </label>
                        </div>
                    </div>
              </div>
        </div>
  </div>
</template>

<script>


export default {
    name: 'selectedPic',
    props: {
      text             : {type:String,default:''},
      formPic          : {type:[Object],default:{}},
      picProperty      : {type:String,default:''},
    },

    data() {
      return  {
        previewImage  : '',
        blobImageFile : {},
      }
    },

    computed: {

    },

    mounted () {


    },

    watch: {
      formPic(data){
        const pic = data[this.picProperty];
        if (typeof(pic) != 'undefined') {
            this.previewImage = pic;

        }

      }
    },

    methods: {
      removePic(){
        this.previewImage           = '';
        this.blobImageFile          = {};

        this.$emit('updateImg',this.blobImageFile);
      },

      uploadImage(e){
         const image = e.target.files[0];
         const reader = new FileReader();
         reader.readAsDataURL(image);
         reader.onload = e =>{
             this.previewImage = e.target.result;
         };

         this.blobImageFile = image;
         this.$emit('updateImg',this.blobImageFile);
     }
    },

}
</script>
